import { TransactionDTO } from "../../../api/transactions/GetAllTransactions";
import TransactionRow from "./TransactionsRow";

const TransactionsTable = ({ data }: { data?: TransactionDTO[] }) => {
  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();
    const hours = date.getHours() % 12 || 12;
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const ampm = date.getHours() >= 12 ? "PM" : "AM";

    return `${day}.${month}.${year} - ${hours}:${minutes} ${ampm}`;
  };

  const formatAmount = (amountCents: number, currency: string) => {
    const amount = amountCents / 100;
    return `${amount.toFixed(2)} ${currency}`;
  };

  return (
    <div>
      <div className="overflow-x-auto scrollbar-thumb-blue scrollbar-thumb-rounded scrollbar-track-blue-lighter scrollbar-w-2 scrolling-touch">
        <table className="table-auto w-full">
          <thead className="text-lg capitalize">
            <tr className="bg-[#F1F4F9] rounded-t-lg">
              <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                <div className="text-left text-sm">Student Name</div>
              </th>
              <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                <div className="text-left text-sm">Email</div>
              </th>
              <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                <div className="text-left text-sm">Paymob Order ID</div>
              </th>
              <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                <div className="text-left text-sm">Amount</div>
              </th>
              <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                <div className="text-left text-sm">Payment Method</div>
              </th>
              <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                <div className="text-left text-sm">Status</div>
              </th>
              <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                <div className="text-left text-sm">Created At</div>
              </th>
              <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                <div className="text-left text-sm">Actions</div>
              </th>
            </tr>
          </thead>
          <tbody className="text-sm">
            {data?.map((transaction: TransactionDTO) => (
              <TransactionRow
                key={transaction.id}
                id={transaction.id}
                studentName={transaction.studentName}
                studentEmail={transaction.studentEmail}
                paymobOrderId={transaction.paymob_order_id}
                amount={formatAmount(transaction.amount_cents, transaction.currency)}
                paymentMethod={`${transaction.source_type} - ${transaction.source_sub_type}`}
                success={transaction.success}
                pending={transaction.pending}
                courses={transaction.courses}
                books={transaction.books}
                packages={transaction.packages}
                createdAt={formatDate(transaction.createdAt)}
              />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TransactionsTable;